module.exports = __webpack_public_path__ + "static/media/odf_logo.ed4dd49d.png";